import { motion } from "framer-motion";
import { Quotes, Star } from "@phosphor-icons/react";

const REVIEWS = [
  {
    text: "Muchas gracias, ya me entregaron mi pedido. Buen servicio.",
    type: "Cliente verificado",
    product: "Entrega a domicilio",
  },
  {
    text: "Sí, excelente. ¡Muchísimas gracias!",
    type: "Cliente verificado",
    product: "Batería solar (power bank)",
  },
  {
    text: "Están muy bonitos, voy a pedir más. ¡Muchas gracias!",
    name: "Flor",
    type: "Cliente verificado",
    product: "Lentes de ciclismo",
  },
  {
    text: "Que Dios te dé mucho trabajo y salud. Gracias por tu honestidad. La próxima quincena voy a querer el primero que me mostraste.",
    name: "José",
    type: "Cliente recurrente",
    product: "WhatsApp",
  },
];

export const Testimonials = () => {
  return (
    <section
      id="voces"
      data-testid="testimonials-section"
      className="py-28 lg:py-36 border-t border-black/10 bg-[#F4F5F6]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-16"
        >
          <h2 className="font-display text-5xl sm:text-6xl uppercase font-semibold leading-none tracking-tight text-[#111418]">
            Lo que dicen quienes ya compraron
          </h2>
          <p className="text-black/55 text-sm mt-4">Mensajes reales de nuestros clientes por WhatsApp</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {REVIEWS.map((r, i) => (
            <motion.blockquote
              key={i}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 2) * 0.12 }}
              className="bg-white border border-black/10 rounded-xl p-8 flex flex-col gap-5 shadow-sm transition-shadow duration-300 hover:shadow-md"
            >
              <Quotes size={40} weight="fill" className="text-[#FF5508]" />
              <div className="flex gap-1" aria-label="5 de 5 estrellas">
                {[0, 1, 2, 3, 4].map((s) => (
                  <Star key={s} size={15} weight="fill" className="text-[#FF5508]" />
                ))}
              </div>
              <p className="text-black/80 text-base leading-relaxed">“{r.text}”</p>
              <footer className="mt-auto pt-2 border-t border-black/5">
                {r.name && <p className="font-bold text-sm text-[#111418]">{r.name}</p>}
                <p className={`font-semibold text-sm ${r.name ? "text-black/50" : "text-[#111418]"}`}>{r.type}</p>
                <p className="text-black/45 text-xs mt-0.5">{r.product}</p>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};
